const collection = {
    slug: "comme-des-garcons-line-guide",
    metaTitle:
      "コムデギャルソンのライン一覧と違い｜COMME des GARÇONS全ブランド完全ガイド",
    metaDescription:
      "コムデギャルソンのラインの違いを知りたい方へ。COMME des GARÇONS、COMME des GARÇONS HOMME PLUS、COMME des GARÇONS HOMME、COMME des GARÇONS HOMME DEUX、COMME des GARÇONS SHIRT、COMME des GARÇONS COMME des GARÇONS、PLAY COMME des GARÇONS、BLACK COMME des GARÇONS、JUNYA WATANABE、noir kei ninomiya、tao COMME des GARÇONSまで、各ラインの特徴・デザイナー・成り立ち・選び方を解説。Enclopediaでレンタルできるアーカイブ体験へ案内します。",
    metaKeywords:
      "コムデギャルソン ライン 違い,コムデギャルソン 種類,コムデギャルソン どんなブランド,COMME des GARCONS ライン,COMME des GARCONS 種類,COMME des GARCONS HOMME PLUS,コムデギャルソンオムプリュス,COMME des GARCONS HOMME,コムデギャルソンオム,COMME des GARCONS HOMME DEUX,コムデギャルソンオムドゥ,COMME des GARCONS SHIRT,COMME des GARCONS COMME des GARCONS,コムコム,PLAY COMME des GARCONS,BLACK COMME des GARCONS,JUNYA WATANABE COMME des GARCONS,JUNYA WATANABE MAN,noir kei ninomiya,tao COMME des GARCONS,COMME des GARCONS GIRL,コムデギャルソン レンタル,Enclopedia,アンクロペディア",
    canonicalPath: "/archive_collection/comme-des-garcons-line-guide",
    heroImage: "media/archive_fashion/archive3.png",
    heroImageAlt:
      "コムデギャルソンのライン一覧と違いを解説するEnclopediaアーカイブガイド画像",
    heroNumber: "03 / LINE GUIDE",
    label: "ARCHIVE BRAND GUIDE",
    title: "コムデギャルソンのライン一覧と違い",
    lead:
      "COMME des GARÇONSは、一つのブランド名で語られがちですが、実際には複数のラインとデザイナーによって構成される巨大なブランド群です。\nCOMME des GARÇONS HOMME PLUS、COMME des GARÇONS HOMME、COMME des GARÇONS HOMME DEUX、COMME des GARÇONS SHIRT、COMME des GARÇONS COMME des GARÇONS、PLAY COMME des GARÇONS、BLACK COMME des GARÇONS、JUNYA WATANABE、noir kei ninomiya、tao COMME des GARÇONS。\nそれぞれのラインは、価格帯や雰囲気が違うだけではありません。\n“どんな服を、誰に、どの距離感で届けるか”が違います。",
    keywordLine: [
      "line guide",
      "comme des garçons",
      "designer lines",
      "rental experience",
    ],
    thesis:
      "コムデギャルソンは、ラインごとの違いを知ると、“難しいブランド”ではなく、自分の入口を選べるブランドに変わります。",
    whyTitle: "コムデギャルソンが気になる。でも、ラインが多すぎて分からない。",
    whyBody:
      "コムデギャルソンを初めて調べると、多くの人が最初に混乱します。\nCOMME des GARÇONSとCOMME des GARÇONS HOMME PLUSは何が違うのか。COMME des GARÇONS HOMMEとCOMME des GARÇONS HOMME DEUXは別物なのか。PLAY COMME des GARÇONSは本格的なギャルソンなのか。JUNYA WATANABEやnoir kei ninomiyaはコムデギャルソンなのか。\nこのページでは、主要ラインの成り立ち、デザイナー、服の特徴、初めて着るならどこから入るべきかを整理します。",
    pillars: [
      {
        number: "01",
        title: "REI KAWAKUBO AS CENTER",
        text:
          "COMME des GARÇONSの中心には、川久保玲による“既存の美しさを疑う”姿勢があります。ブランド本体とCOMME des GARÇONS HOMME PLUSでは、その思想が最も強く表れます。",
      },
      {
        number: "02",
        title: "MANY DESIGNERS, MANY ENTRIES",
        text:
          "JUNYA WATANABE、noir kei ninomiya、tao COMME des GARÇONSなど、コムデギャルソンの中から生まれた才能は、それぞれ異なる角度から服を更新しています。",
      },
      {
        number: "03",
        title: "FROM DAILY TO RUNWAY",
        text:
          "COMME des GARÇONS SHIRTやPLAY COMME des GARÇONSのような入口に近いラインから、COMME des GARÇONS HOMME PLUSのようなランウェイ性の強いラインまで、体験の距離が大きく異なります。",
      },
    ],
    readingTitle: "主要ラインから読む、COMME des GARÇONSというブランド宇宙。",
    readingIntro:
      "ラインの違いを理解すると、コムデギャルソンは“全部難しい服”ではなく、日常に近い入口から強いコレクションピースまで、自分に合う距離で触れられるブランドだと分かります。",
    observations: [
      {
        index: "01",
        title: "COMME des GARÇONS",
        text:
          "Designer：川久保玲\nStarted：1969年\nブランドの中核。既存の美しさや服の普通を問い直す最もコンセプチュアルなラインです。身体を変形させる造形、黒、非対称、膨らみ、余白など、コムデギャルソンの思想が最も濃く表れます。\nおすすめ：コムデギャルソンを思想ごと知りたい人。アートピースのような服を体験したい人。",
      },
      {
        index: "02",
        title: "COMME des GARÇONS HOMME PLUS",
        text:
          "Designer：川久保玲\nStarted：1984年\nコムデギャルソン オムプリュスは、メンズコレクションにおける実験の中心です。テーラード、スーツ、パンツ、ミリタリー、装飾を大胆に再構成し、男性服の前提を揺さぶります。\nおすすめ：メンズのギャルソンらしさを強く体験したい人。ランウェイ性のある服を着てみたい人。",
      },
      {
        index: "03",
        title: "COMME des GARÇONS HOMME",
        text:
          "Designer：川久保玲 / 田中啓一 / 渡辺淳弥ほか\nStarted：1978年\nコムデギャルソン オムは、メンズの日常着に近いラインです。シャツ、ジャケット、パンツなどをベースにしながら、素材、柄、パッチワーク、シルエットにギャルソンらしさを残します。COMME des GARÇONS HOMME PLUSより生活に近い入口です。\nおすすめ：最初のコムデギャルソンとして、日常に取り入れやすいメンズ服を探している人。",
      },
      {
        index: "04",
        title: "COMME des GARÇONS HOMME DEUX",
        text:
          "Designer：川久保玲監修 / デザインチーム\nStarted：1987年\nコムデギャルソン オム ドゥは、スーツやジャケットを軸にしたテーラードラインです。ビジネスやフォーマルに近い形を保ちながら、生地、裏地、ボタン、シルエットに静かな違和感を入れます。\nおすすめ：仕事着やセットアップに近い距離でギャルソンを体験したい人。",
      },
      {
        index: "05",
        title: "COMME des GARÇONS SHIRT",
        text:
          "Designer：川久保玲監修 / デザインチーム\nStarted：1988年\nコムデギャルソン シャツは、シャツを中心にしたラインです。ストライプ、パッチワーク、切替、プリント、ポップな色使いが特徴で、ギャルソンの発想を軽やかに体験できます。\nおすすめ：初めての一着として、強すぎないけれど普通ではない服を着たい人。",
      },
      {
        index: "06",
        title: "COMME des GARÇONS COMME des GARÇONS",
        text:
          "Designer：川久保玲監修 / デザインチーム\nStarted：1993年ごろ\nコムデギャルソン コムデギャルソン、通称コムコム。ウィメンズの日常に近いラインで、フリル、丸襟、ギャザー、黒、ドット、チェックなどを用いながら、可愛さと違和感を共存させます。\nおすすめ：日常に近い距離で、ギャルソンのかわいさと癖を体験したい人。",
      },
      {
        index: "07",
        title: "PLAY COMME des GARÇONS",
        text:
          "Designer：川久保玲監修 / Filip Pagowskiによるハートロゴ\nStarted：2002年\nプレイ コムデギャルソンは、ハートロゴで知られる最も分かりやすい入口です。Tシャツ、カーディガン、シャツ、Converseコラボなどが中心で、ファッション初心者にも認知されやすいラインです。\nおすすめ：まずはロゴやベーシックなアイテムからコムデギャルソンに触れたい人。",
      },
      {
        index: "08",
        title: "BLACK COMME des GARÇONS",
        text:
          "Designer：川久保玲監修 / デザインチーム\nStarted：2009年\nブラック コムデギャルソンは、黒を軸に、過去のコムデギャルソン的要素を比較的手に取りやすい形で展開するラインです。ジャケット、シャツ、パンツなど、黒のギャルソンを入口として体験しやすいです。\nおすすめ：黒いギャルソンを着たいが、メインラインほど強すぎる服にはまだ抵抗がある人。",
      },
      {
        index: "09",
        title: "JUNYA WATANABE COMME des GARÇONS",
        text:
          "Designer：渡辺淳弥\nStarted：1992年\nジュンヤワタナベ コムデギャルソンは、パッチワーク、再構築、デニム、異素材、コラボレーションを得意とするデザイナーラインです。服をゼロから作るというより、既存の服を読み替え、別の服へ編集する感覚が強いです。\nおすすめ：デニム、ワーク、ミリタリー、コラボレーションからコムデギャルソンを知りたい人。",
      },
      {
        index: "10",
        title: "JUNYA WATANABE MAN",
        text:
          "Designer：渡辺淳弥\nStarted：2001年ごろ\nジュンヤワタナベ マンは、JUNYA WATANABEのメンズラインです。Levi's、THE NORTH FACE、Brooks Brothersなど、実在する服の歴史や機能を再編集するコラボレーションが多く、男性にも入りやすいラインです。\nおすすめ：ワークウェアやアウトドアを軸に、ひねりのある服を着たい人。",
      },
      {
        index: "11",
        title: "noir kei ninomiya",
        text:
          "Designer：二宮啓\nStarted：2012年\nノワール ケイ ニノミヤは、黒を軸に、チュール、ハーネス、スタッズ、リング、パーツ接続を用いて服を立体的に構築するブランドです。可愛い黒ではなく、黒を構造として見せます。\nおすすめ：黒、チュール、構築的なジャケットやドレスに興味がある人。",
      },
      {
        index: "12",
        title: "tao COMME des GARÇONS",
        text:
          "Designer：栗原たお\nStarted：2005年 / 2022年にtaoとして再始動\nタオ コムデギャルソンは、フリル、レース、パッチワーク、プリント、手仕事感のあるディテールが特徴です。強い前衛性よりも、日常の中に軽やかな違和感を入れるラインです。\nおすすめ：コムデギャルソンの中でも、軽さ、可愛さ、クラフト感のある服から入りたい人。",
      },
      {
        index: "13",
        title: "COMME des GARÇONS GIRL",
        text:
          "Designer：川久保玲監修 / デザインチーム\nStarted：2015年ごろ\nコムデギャルソン ガールは、少女性や制服的なムードを含みながら、ギャルソンらしい違和感を持つラインです。リボン、丸襟、チェック、フリルなど、分かりやすい可愛さの中に癖があります。\nおすすめ：可愛いギャルソン、若々しいギャルソンを探している人。",
      },
    ],
    quote:
      "コムデギャルソンは一つではない。だから、自分に合う入口が必ずある。",
    perspectiveTitle: "Enclopediaは、ラインの違いを“知識”から“体験”へ変える。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "COMME des GARÇONS HOMME PLUS、COMME des GARÇONS HOMME、COMME des GARÇONS SHIRTなど、名前だけでは分かりづらいラインの違いを整理します。",
      },
      {
        number: "02",
        title: "EXPERIENCE",
        text:
          "ラインの違いは、実際に着ると一気に分かります。強く見える服が意外と馴染むことも、普通に見える服に違和感が潜むこともあります。",
      },
      {
        number: "03",
        title: "ENTRY",
        text:
          "どのラインが自分に合うのかを、購入前にレンタルで確かめる。Enclopediaは、コムデギャルソンへの入口を所有ではなく体験から作ります。",
      },
    ],
    experienceTitle: "初めてなら、どのCOMME des GARÇONSから入るべきか。",
    experienceBody:
      "コムデギャルソンは、ラインによって入口がまったく違います。\n強いランウェイ性を求めるならCOMME des GARÇONS HOMME PLUS。日常に近いメンズならCOMME des GARÇONS HOMMEやCOMME des GARÇONS HOMME DEUX。軽く試すならCOMME des GARÇONS SHIRT、PLAY COMME des GARÇONS、BLACK COMME des GARÇONS。\nそして服の構造そのものを楽しみたいなら、JUNYA WATANABE、noir kei ninomiya、tao COMME des GARÇONSが入口になります。",
    experienceItems: [
      "強いギャルソンを体験したいならCOMME des GARÇONS HOMME PLUS",
      "日常に近いメンズならCOMME des GARÇONS HOMME / COMME des GARÇONS HOMME DEUX",
      "軽く試すならCOMME des GARÇONS SHIRT / PLAY COMME des GARÇONS / BLACK COMME des GARÇONS",
      "服の構造を楽しむならJUNYA WATANABE / noir kei ninomiya / tao COMME des GARÇONS",
    ],
    archiveItemsTitle: "ラインの違いを、実物で確かめる。",
    archiveItemsBody:
      "Enclopediaでは、COMME des GARÇONS HOMME PLUSを中心に、COMME des GARÇONS、JUNYA WATANABE、noir kei ninomiyaなど、ラインごとの違いを実物で体験できるアーカイブを扱っています。",
    archiveItems: [
      {
        label: "ARCHIVE FOCUS 01",
        title: "COMME des GARÇONS HOMME PLUS",
        productPath:
          "/brand/COMME%20DES%20GARCONS%20HOMME%20PLUS（コムデギャルソンオムプリュス）/?number=11",
        productImage: "",
        text:
          "テーラード、ランウェイピース、シーズンテーマの強い一着を体験したい方へ。男性服の前提を揺さぶる、最も実験的な入口です。",
      },
      {
        label: "ARCHIVE FOCUS 02",
        title: "COMME des GARÇONS",
        productPath: "/brand/COMME%20DES%20GARCONS（コムデギャルソン）/?number=10",
        productImage: "",
        text:
          "ブランドの中核となる思想や造形を、実際の服で確かめたい方へ。黒、余白、非対称、身体の見え方を読む入口です。",
      },
      {
        label: "ARCHIVE FOCUS 03",
        title: "JUNYA WATANABE",
        productPath: "/brand/JUNYA%20WATANABE（ジュンヤワタナベ）/?number=32",
        productImage: "",
        text:
          "パッチワーク、再構築、ワークウェア、コラボレーションから入りたい方へ。既存の服をもう一度編集する面白さを体験できます。",
      },
    ],
  };

export default collection;
